import * as React from 'react';
import { useSetAtom } from 'jotai';

import { getAssetSrc } from '@restworld/utils-common';

import { isPDFReadyAtom } from '.';

interface IRestaurantShowCaseQRProps {
  restaurantDetailsQR?: string;
}

const RestaurantShowCaseFullPageQRA4 = React.forwardRef<HTMLDivElement, IRestaurantShowCaseQRProps>(
  ({ restaurantDetailsQR = '' }, ref) => {
    const setIsPDFReady = useSetAtom(isPDFReadyAtom);
    const canvasRef = React.useRef<HTMLCanvasElement>(null);

    const loadImage = (src: string): Promise<HTMLImageElement> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    };

    const drawImageRotated = (
      ctx: CanvasRenderingContext2D,
      img: HTMLImageElement,
      [x, y, width, height]: [number, number, number, number]
    ) => {
      ctx.save();
      ctx.translate(x + width / 2, y + height / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.drawImage(img, -width / 2, -height / 2, width, height);
      ctx.restore();
    };

    React.useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const canvasHeight = 707 * 2.87;
      const canvasWidth = 540 * 2.87;
      const qrTemplateSrc = getAssetSrc('/utils-assets/restworld-a4-qr-template.jpg');

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      loadImage(qrTemplateSrc)
        .then((qrTemplate) => {
          ctx.drawImage(qrTemplate, 0, 0, canvasWidth, canvasHeight);
        })
        .catch((error) => console.error('Error loading qr-template image', error));
    }, []);

    React.useEffect(() => {
      setTimeout(() => {
        if (!restaurantDetailsQR) return;
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const qrImageDrawCoords: [number, number, number, number][] = [
          [287 * 2.87, 335 * 2.5, 170 * 1.5, 170 * 1.5],
          [287 * 2.87, 625 * 2.5, 170 * 1.5, 170 * 1.5],
        ];

        loadImage(restaurantDetailsQR)
          .then((qrImage) => {
            qrImageDrawCoords.forEach((coords) => drawImageRotated(ctx, qrImage, coords));
            setIsPDFReady(true);
          })
          .catch((error) => console.error('Error loading qr image', error));
      }, 500);
    }, [restaurantDetailsQR, setIsPDFReady]);

    return (
      <div ref={ref}>
        <div className="w-full h-full">
          <canvas ref={canvasRef} />
        </div>
      </div>
    );
  }
);

export default RestaurantShowCaseFullPageQRA4;
